import { FC, ReactNode, useEffect } from 'react';
import { useAuth0 } from '../auth/AuthProvider';
import { CircularProgress } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';

interface AuthenticatedRouteProps {
  children: ReactNode;
}

const AuthenticatedRoute: FC<AuthenticatedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const currentUrl = location.pathname + location.search;

      if (!currentUrl.includes('/login') && !currentUrl.includes('/callback')) {
        if (!localStorage.getItem('redirectAfterLogin')) {
          localStorage.setItem('redirectAfterLogin', currentUrl);
        }
      }
    }
  }, [isAuthenticated, isLoading, location]);

  if (isLoading) {
    return (
      <div
        className="flex justify-center items-center min-h-[40vh]"
        role="status"
        aria-live="polite"
        aria-label="Checking sign-in"
      >
        <CircularProgress />
      </div>
    );
  }

  if (!isAuthenticated && location.pathname !== '/callback') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
